{
  "asset_id": "1c0c9d56-0d0f-498c-a0e8-e9c70e514adf",
  "content_type": "image/png",
  "created_at": "2026-09-07T20:18:59Z",
  "original_filename": "subido-pro-logo.png",
  "project_id": "2e05451c-9ac5-4503-b5ea-624bd8d09e1e",
  "r2_key": "a/v1/2e05451c-9ac5-4503-b5ea-624bd8d09e1e/1c0c9d56-0d0f-498c-a0e8-e9c70e514adf/subido-pro-logo.png",
  "size": 1737,
  "url": "/__l5e/assets-v1/1c0c9d56-0d0f-498c-a0e8-e9c70e514adf/subido-pro-logo.png",
  "version": 1
}